<div class="container-fluid register-container">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-10 col-lg-12 col-xl-12">
            <div class="center-screen">
                <div class="row justify-content-center">
                    <div class="col-10 col-sm-11 col-md-12 col-lg-8 col-xl-6">
                        <div class="not-found-container">
                            <div class="not-found-code">404</div>
                            <div class="not-found-info">
                                <div>Página no encontrada</div>
                            </div>
                            <div class="not-found-eyes">
                                <img src="/assets/img/bg/not-found-eyes.png" alt="">
                            </div>
                            <img src="/assets/img/bg/not-found-image.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>